export const OpenMap = {
    OPEN: 1,
    CLOSE: 0,
};

export const VerifyCodeMap = {
    LOGIN: 'VERIFICATION_BULLET',
};
